import { graphql } from '@/gql';
import type { GetHomeServiceOrdersQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrder } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderFragment';

export const getHomeServiceOrders = async ({
  searchType,
  searchValue,
  dateSearchType,
  dateSearchValue,
  serviceType,
  status,
  orderBy,
  sortType,
  pagination,
}: GetHomeServiceOrdersQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      searchType,
      searchValue,
      dateSearchType,
      dateSearchValue,
      serviceType,
      status,
      orderBy,
      sortType,
      pagination,
    },
    query: graphql(`
      query GetHomeServiceOrders(
        $searchType: String!
        $searchValue: String
        $dateSearchType: String!
        $dateSearchValue: DatePeriod
        $serviceType: HomeServiceType
        $status: [String!]
        $orderBy: String
        $sortType: QuerySortType
        $pagination: PaginationInputType
      ) {
        getHomeServiceOrders(
          searchType: $searchType
          searchValue: $searchValue
          dateSearchType: $dateSearchType
          dateSearchValue: $dateSearchValue
          serviceType: $serviceType
          status: $status
          orderBy: $orderBy
          sortType: $sortType
          pagination: $pagination
        ) {
          count
          rows {
            ...HomeServiceOrderFragment
          }
        }
      }
    `),
  });

  return response.data.getHomeServiceOrders as {
    count: number;
    rows: HomeServiceOrder[];
  };
};
